import type {Tier, Verdict} from "../types/shouldCostTypes";
import {formatUnitPrice} from './unitPrice';

export const VERDICT: Record<Verdict, {label: string; color: 'success' | 'warning' | 'error'}> = {
    accept: {label: 'Accept', color: 'success'},
    validate: {label: 'Validate', color: 'warning'},
    challenge: {label: 'Challenge', color: 'error'},
};

export const TIER_COLOR: Record<Tier, string> = {live: '#1E9E5A', modeled: '#2D6FF5', manual: '#D4A23A', estimated: '#9AA1AD'};

/** A unit price in the model's currency (see `formatUnitPrice`). */
export const unitPrice = (value: number | null, currency: string): string => formatUnitPrice(value, currency);

export const pct = (v: number | null) => (v === null ? '—' : `${v > 0 ? '+' : ''}${v.toFixed(1)}%`);

/** Share of a line in the total (0-100), for bars. */
export function share(part: number, total: number): number {
    return total > 0 ? Math.max(0, Math.min(100, part / total * 100)) : 0;
}
